import NavigateBack from "../../components/navigateBack";
import { useTranslation } from "react-i18next";
import { ReactComponent as PDFIcon } from "../../img/icons/icon_pdf.svg";
import { ReactComponent as MessageIcon } from "../../img/icons/icon_msg.svg";
import createPersistedState from "use-persisted-state";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Modal } from "react-bootstrap";
import { Grid, Container, Typography, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

//TODO: To refactor
//TODO: Hardcoded english text requires translations
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useReportsViewedState = createPersistedState("reportsViewed");

const useStyles = makeStyles((theme) => ({
  selectedTab: {
    backgroundColor: "#0e426a",
    height: 50,
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  unselectedTab: {
    backgroundColor: "#97d1fa57",
    height: 50,
    color: "#0060a6b3",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function MyReports() {
  const { t } = useTranslation();
  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [reportsViewed, setReportsViewed] = useReportsViewedState();
  let [isFetchingRecent, setIsFetchingRecent] = useState(false);
  let [isFetchingOld, setIsFetchingOld] = useState(false);
  let [error, setError] = useState("");
  let [recentReports, setRecentReports] = useState([]);
  let [oldReports, setOldReports] = useState([]);

  let [noRecentReports, setNoRecentReports] = useState(false);
  let [noOldReports, setNoOldReports] = useState(false);
  const stdMsg =
    "Your reports have been seen by Dr. Akerkar. Please continue with the same medications.";

  const getUrl = () => `/api/v1/users/profile/${pid}/reports`;
  const getArchivedUrl = () =>
    `/api/v1/users/profile/${pid}/reports?archived=true`;
  const [showModal, setShowModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState({});
  const handleClose = () => {
    setShowModal(false);
  };
  const classes = useStyles();
  const [tab, setTab] = React.useState(0);

  // TODO: Find a better way todo this!
  const getDateOfMostRecentReport = (reportName) => {
    const nameSplit = reportName.split("-");
    const x = nameSplit.length;
    return nameSplit[x - 1] + "-" + nameSplit[x - 2] + "-" + nameSplit[x - 3];
  };

  const fetchReports = () => {
    setIsFetchingRecent(true);
    setNoRecentReports(false);
    setIsFetchingOld(true);
    setNoOldReports(false);
    setError("");
    fetch(getUrl(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          if (responseData["reports"].length <= 0) {
            setNoRecentReports(true);
          } else {
            setReportsViewed(
              getDateOfMostRecentReport(responseData["reports"][0].name)
            );
          }
          setRecentReports(
            responseData["reports"].map((report, index, _reports) => {
              return {
                name: report.name,
                signedUrl: report.signedUrl,
                id: index,
                note: report.note,
                date: report.noteDate,
              };
            })
          );
        } else {
          setError(responseData["status"]["message"]);
        }
      })
      .catch((e) => {
        setError(t("testReports.reportsFetchError") + ": " + e.message);
      })
      .finally(() => {
        setIsFetchingRecent(false);
      });

    fetch(getArchivedUrl(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          if (responseData["reports"].length <= 0) {
            setNoOldReports(true);
          } else {
            /*
             * IMPORTANT NOTE: Beryl, Caron I've intentionally commented the following lines.
             * I will eventually remove it, if we save the date of the archived / old reports
             * in localstorage then it overrides the last seen reports status of the latest reports
             * This causes the report notification to always popup on the home page inspite of viewing
             * the reports.
            setReportsViewed(
              getDateOfMostRecentReport(responseData["reports"][0].name)
            );
             */
          }
          setOldReports(
            responseData["reports"].map((report, index, _reports) => {
              return {
                name: report.name,
                signedUrl: report.signedUrl,
                id: index,
                note: report.note,
                date: report.noteDate,
              };
            })
          );
        } else {
          setError(responseData["status"]["message"]);
        }
      })
      .catch((e) => {
        setError(t("testReports.reportsFetchError") + ": " + e.message);
      })
      .finally(() => {
        setIsFetchingOld(false);
      });
  };

  useEffect(() => {
    fetchReports();
  }, [pid, token]);

  const dummyReports = [
    {
      id: 1,
      name: "Pathology-report-Madhavi.pdf",
      date: "03/06/2021",
    },
    {
      id: 2,
      name: "Bodyscan-report-Madhavi.pdf",
      date: "03/06/2021",
    },
  ];

  const recentReportListing = recentReports.map((report) => (
    <li key={report.id}>
      <a href={report.signedUrl} download={true} target="_blank">
        <div className="box_pdf d-flex align-items-center justify-content-between">
          <div className="left_position">
            <span className="icon">
              <PDFIcon />
            </span>
            <span className="txt_desc mb-0">{report.name}</span>
          </div>
        </div>
      </a>
      <div
        className="box_pdf d-flex align-items-center justify-content-between"
        style={{
          backgroundColor: "#EBF0F3",
          padding: "10px 0 10px 0",
        }}
      >
        <Grid container spacing={0}>
          <Grid item xs={1}>
            <span className="icon">
              <MessageIcon style={{ height: "20px" }} />
            </span>
          </Grid>
          <Grid item xs={9}>
            <span
              className="txt_desc mb-0"
              style={{ fontSize: "10px", color: "#2C2C2C" }}
            >
              {t("testReports.doctorsComment")}
            </span>
          </Grid>
          <Grid item xs={2}>
            <span
              className="txt_desc mb-0"
              style={{ fontSize: "10px", color: "#2C2C2C" }}
            >
              {report.date}
            </span>
          </Grid>
          <Grid item xs={12}>
            {report.note === stdMsg ? (
              <div
                className="txt_desc mb-3"
                style={{ fontSize: "12px", color: "#2C2C2C", margin: 10 }}
              >
                {t("onboard.REPORTS.std_note")}
              </div>
            ) : (
              <div
                className="txt_desc mb-3"
                style={{ fontSize: "12px", color: "#2C2C2C", margin: 10 }}
              >
                {report.note}
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </li>
  ));

  const oldReportListing = oldReports.map((report) => (
    <li key={report.id}>
      <a href={report.signedUrl} download={true} target="_blank">
        <div className="box_pdf d-flex align-items-center justify-content-between">
          <div className="left_position">
            <span className="icon">
              <PDFIcon />
            </span>
            <span className="txt_desc mb-0">{report.name}</span>
          </div>
        </div>
      </a>
      <div
        className="box_pdf d-flex align-items-center justify-content-between"
        onClick={() => {
          setSelectedReport(report);
          setShowModal(true);
        }}
        style={{
          backgroundColor: "#EBF0F3",
          padding: "10px 0 10px 0",
        }}
      >
        <div className="left_position">
          <span className="icon">
            <MessageIcon style={{ height: "20px" }} />
          </span>
          <span
            className="txt_desc mb-0"
            style={{ fontSize: "10px", color: "#2C2C2C" }}
          >
            {t("testReports.doctorsComment")}
          </span>
        </div>
      </div>
    </li>
  ));

  return (
    <>
      <NavigateBack title={t("testReports.reportsOption")} />
      <div style={{ marginTop: "78px" }}>
        <Grid container spacing={0}>
          <Grid item xs={6}>
            <Container
              maxWidth="sm"
              disableGutters
              onClick={() => {
                setTab(0);
              }}
            >
              <Typography
                component="div"
                className={
                  tab === 0 ? classes.selectedTab : classes.unselectedTab
                }
              >
                {t("testReports.recentReports")}
              </Typography>
            </Container>
          </Grid>
          <Grid item xs={6}>
            <Container
              maxWidth="sm"
              disableGutters
              onClick={() => {
                setTab(1);
              }}
            >
              <Typography
                component="div"
                className={
                  tab === 1 ? classes.selectedTab : classes.unselectedTab
                }
              >
                {t("testReports.oldReports")}
              </Typography>
            </Container>
          </Grid>
        </Grid>
      </div>

      {tab === 0 ? (
        <div className="body_padding ">
          <div className="inner_body">
            <span
              className="txt_desc mb-0"
              style={{
                fontSize: "10px",
                color: "#146daf",
                display: "flex",
              }}
            >
              {t("testReports.recentReportsRecieved")}
            </span>
            {isFetchingRecent && (
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
                id="loader"
              ></div>
            )}
            {error !== "" && <span className="txt_msg">{error}</span>}
            {noRecentReports && (
              <span>{t("testReports.noRectentReports")}</span>
            )}
            <div style={{ marginTop: "1em" }}></div>
            <ul className=" list_pdf">{recentReportListing}</ul>
            <div style={{ marginTop: "1em" }}></div>
          </div>
        </div>
      ) : (
        <div className="body_padding ">
          <div className="inner_body">
            <span
              className="txt_desc mb-0"
              style={{
                fontSize: "10px",
                color: "#146daf",
                display: "flex",
              }}
            >
              {t("testReports.pastReportsRecieved")}
            </span>
            {isFetchingOld && (
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
                id="loader"
              ></div>
            )}
            {error !== "" && <span className="txt_msg">{error}</span>}
            {noOldReports && <span>{t("testReports.noReports")}</span>}
            <div style={{ marginTop: "1em" }}></div>
            <ul className=" list_pdf">{oldReportListing}</ul>
            <div style={{ marginTop: "1em" }}></div>
          </div>
        </div>
      )}
      <Modal show={showModal} onHide={handleClose} className="custom_modal">
        <Modal.Header>
          {selectedReport.name}
          <CloseIcon onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Grid container spacing={0}>
            <Grid item xs={9}>
              <span
                className="txt_desc mb-0"
                style={{ fontSize: "10px", color: "#2C2C2C" }}
              >
                {t("testReports.doctorsComment")}
              </span>
            </Grid>
            <Grid item xs={2}>
              <span
                className="txt_desc mb-0"
                style={{ fontSize: "10px", color: "#2C2C2C" }}
              >
                {selectedReport.date}
              </span>
            </Grid>
          </Grid>
          <div className="reports-notification-modal">
            <div className="d-flex justify-content-center">
              {selectedReport.note === stdMsg ? (
                <span
                  className="txt_desc mb-0"
                  style={{ fontSize: "15px", color: "#2C2C2C" }}
                >
                  {t("onboard.REPORTS.std_note")}
                </span>
              ) : (
                <span
                  className="txt_desc mb-0"
                  style={{ fontSize: "15px", color: "#2C2C2C" }}
                >
                  {selectedReport.note}
                </span>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MyReports;
